export default __webpack_public_path__ + "static/media/searinglight.c892c1b3.png";